import { render, staticRenderFns } from "./index.vue?vue&type=template&id=156f53df&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adaptiv.css?vue&type=style&index=0&id=156f53df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f53df",
  null
  
)

export default component.exports